export default __webpack_public_path__ + "static/media/logo.c4785b22.svg";